/* ------------------------------------------------------------------ */
/* fe-infinite-articles.js — 博客列表页的无限加载（Flora Encore，二类） */
/*                                                                     */
/* Shrine 自带的 <infinite-products>（assets/secondary.js）只服务集合页：*/
/* 它写死了 document.getElementById('product-grid')，并且只搬运          */
/* `:scope > li`。博客列表是 .blog-articles > .blog-articles__article    */
/* 这样的 div 结构，两个前提都不成立，所以照抄不能用。                   */
/*                                                                     */
/* 这里复刻同一套交互（IntersectionObserver 提前 400px 触发 → fetch 下  */
/* 一页 → 搬运卡片 → 更新或摘除哨兵），只把容器与子元素选择器换成博客的。*/
/* 行为、类名、loading 态与集合页保持一致，两处体验相同。               */
/* ------------------------------------------------------------------ */

class FeInfiniteArticles extends HTMLElement {
  constructor() {
    super();
    this.sentinel = this.querySelector('[data-infinite-sentinel]');
    this.loading = false;
    this.observer = null;
  }

  connectedCallback() {
    if (!this.sentinel) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading) this.loadMore();
      },
      { rootMargin: '400px 0px' }
    );
    this.observer.observe(this.sentinel);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  async loadMore() {
    const nextUrl = this.sentinel.dataset.nextUrl;
    const container = document.querySelector('[data-fe-articles-grid]');
    if (!nextUrl || !container) return;

    this.loading = true;
    this.sentinel.classList.add('infinite-sentinel--loading');

    try {
      const res = await fetch(nextUrl);
      if (!res.ok) throw new Error(`Request failed: ${res.status}`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      const nextGrid = doc.querySelector('[data-fe-articles-grid]');
      if (nextGrid) {
        nextGrid
          .querySelectorAll(':scope > .blog-articles__article')
          .forEach((card) => container.appendChild(card));
      }

      // 下一页还有下一页就续上 URL，否则摘掉哨兵、停止观察。
      const nextSentinel = doc.querySelector('[data-infinite-sentinel]');
      const followingUrl = nextSentinel && nextSentinel.dataset.nextUrl;
      if (followingUrl) {
        this.sentinel.dataset.nextUrl = followingUrl;
      } else {
        this.observer.disconnect();
        this.sentinel.remove();
      }
    } catch (err) {
      console.error('Infinite load (articles) failed:', err);
    } finally {
      this.loading = false;
      if (this.sentinel) this.sentinel.classList.remove('infinite-sentinel--loading');
    }
  }
}

customElements.define('fe-infinite-articles', FeInfiniteArticles);
